import mixpanel from 'mixpanel-browser';

mixpanel.init('1e51739da351b97027b99abdd4b79a36', {
	batch_requests: false,
});

const getUrlVars = () => {
	var array = [],
		hash;
	var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1)
		.split('&');
	for (var i = 0; i < hashes.length; i++) {
		hash = hashes[i].split('=');
		array.push(hash[0]);
		array[hash[0]] = hash[1];
	}
	return array;
};

function trackClick(place) {
	console.log(place);
	mixpanel.track('click', {
		place,
		lending_number: 10,
	}, {
		send_immediately: true,
	});
}

export function trackPassword() {
	mixpanel.track('input_password', {
		lending_number: 10,
	}, {
		send_immediately: true,
	});
}

export function trackEmail(email) {
	mixpanel.track('input_mail', {
		email,
		lending_number: 10,
	}, {
		send_immediately: true,
	});
}

function trackVisitLending() {
	mixpanel.track('visit_lending', {
		lending_number: 10,
		ad_id: getUrlVars()['offerId'] || 'default_offer_id',
		click_id: getUrlVars()['clickId'] || 'default_click_id',
		affiliate_id: getUrlVars()['affiliateId'] || 'default_affiliate_id',
	}, {
		send_immediately: true,
	});
}

function trackRegister() {
	mixpanel.track('registration_lending', {
		lending_number: 10,
		ad_id: getUrlVars()['offerId'] || 'default_offer_id',
		click_id: getUrlVars()['clickId'] || 'default_click_id',
		affiliate_id: getUrlVars()['affiliateId'] || 'default_affiliate_id',
	}, {
		send_immediately: true,
	});
}

export const init = () => {
	trackVisitLending();

	document.getElementById('Explore_button').onclick = () => trackClick('Explore_button');
	document.getElementById('Generate_image_button').onclick = () => trackClick('Generate_image_button');
	document.getElementById('Create_character_button').onclick = () => trackClick('Create_character_button');
	document.getElementById('Chat_button').onclick = () => trackClick('Chat_button');
	document.getElementById('Create_account_button').onclick = () => trackClick('Create_account_button');
	document.getElementById('First_banner_1').onclick = () => trackClick('First_banner_1');
	document.getElementById('Get_started_for_free_button_1').onclick = () => trackClick('Get_started_for_free_button_1');
	document.getElementById('Top_button_2').onclick = () => trackClick('Top_button_2');
	document.getElementById('Newest_button_2').onclick = () => trackClick('Newest_button_2');
	document.getElementById('Video_button_2').onclick = () => trackClick('Video_button_2');
	document.getElementById('Following_button_2').onclick = () => trackClick('Following_button_2');
	document.getElementById('All_styles_button_2').onclick = () => trackClick('All_styles_button_2');
	document.getElementById('Model_cart_name_1').onclick = () => trackClick('Model_cart_name_1');
	document.getElementById('Model_cart_name_2').onclick = () => trackClick('Model_cart_name_2');
	document.getElementById('Model_cart_name_3').onclick = () => trackClick('Model_cart_name_2');
	document.getElementById('Model_cart_name_4').onclick = () => trackClick('Model_cart_name_2');
	document.getElementById('Model_cart_name_5').onclick = () => trackClick('Model_cart_name_2');
	document.getElementById('Model_cart_name_6').onclick = () => trackClick('Model_cart_name_2');
	document.getElementById('Sign_up_for_free_button_2').onclick = () => trackClick('Sign_up_for_free_button_2');
	document.getElementById('Second_banner_3').onclick = () => trackClick('Second_banner_3');
	document.getElementById('Get_started_button_3').onclick = () => trackClick('Get_started_button_3');
	document.getElementById('Get_started_button_4').onclick = () => trackClick('Get_started_button_4');
	document.getElementById('Get_started_button_5').onclick = () => trackClick('Get_started_button_5');
	document.getElementById('Get_started_button_6').onclick = () => trackClick('Get_started_button_6');
	document.getElementById('Get_started_button_7').onclick = () => trackClick('Get_started_button_7');
	document.getElementById('Get_started_button_8').onclick = () => trackClick('Get_started_button_8');
	document.getElementById('Get_started_private_button_9').onclick = () => trackClick('Get_started_private_button_9');
	document.getElementById('Get_started_uncensored_button_9').onclick = () => trackClick('Get_started_uncensored_button_9');
	document.getElementById('Get_started_on_the_go_button_9').onclick = () => trackClick('Get_started_on_the_go_button_9');
	document.getElementById('Get_started_lightning_fast_button_9').onclick = () => trackClick('Get_started_lightning_fast_button_9');
	document.getElementById('Third_banner_10').onclick = () => trackClick('Third_banner_10');
};

export {trackRegister};
